// noinspection CssNoGenericFontName,HtmlRequiredAltAttribute,HtmlUnknownAttribute

export const slidesScratch = [
  {
    activityType: null,
    background: null,
    content:
      '<figure class="table">\n <table style="border:3px solid transparent;">\n  <tbody>\n   <tr>\n    <td style="border:3px solid transparent;"><img src="https://codefeverpublic.blob.core.windows.net/public-content/images/2f71b57408214b339707bc53280c593c.png" alt=""></td>\n   </tr>\n  </tbody>\n </table>\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035985',
    info: '<h3 class="ck5h3">Overzicht van deze missie:</h3><p><span style="background-color:#ffffff;color:#000000;">In deze les wordt er dieper ingegaan op de oneindige lus. Na de herhalingen van het theoretische luik, analyseren de leerlingen het spel dat ze gaan programmeren. Zodra ze decompositie hebben toegepast, starten ze met het programmeren van de uitdaging. Wanneer dat gelukt is, kan de crew de eerste testvlucht maken. Zijn er snelle werkers? Er is nog een extra uitdaging voorzien waarbij de leerlingen RONN-1E besturen tot aan de knop om de lasers uit te zetten. &nbsp;</span></p><p><span><strong>Aan te brengen concepten computationeel denken:</strong></span></p><ul><li><span style="background-color:#ffffff;color:#000000;">Oneindige lus</span></li></ul><p><span><strong>Aan te brengen Scratch-blokjes:</strong></span></p><ul><li><span>Richt naar 180 graden</span></li><li><span>Richt naar 0 graden</span></li></ul><p style="margin-left:0;">&nbsp;</p><p style="margin-left:0;"><span id="cke_bm_1103S"><strong>&nbsp;</strong></span><strong>Overzicht van de module:</strong></p><p><span style="background-color:#ffffff;color:#000000;">In dit overzicht kan je de volgorde bekijken van hoe de concepten van programmeren en computationeel denken&nbsp;verwerkt zitten in de lessen.</span></p><p class="SlideViewer__Badge tip"><strong>TIP</strong><br>Sleep de lerarenhandleiding naar rechts om de afbeelding te vergroten.</p><p><img src="https://codefeverpublic.blob.core.windows.net/public-content/images/882cd84202284084b58f19cdc3aeec2c.jpg" alt=""></p><p>&nbsp;</p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 1,
    time: null,
    title: 'Missie 7',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">herhaling</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/f8813abf33b941378f0a12ef9e5312cd.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059739',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 2,
    time: null,
    title: 'Herhaling',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling</h2>\n<figure class="image image_resized" style="width:1139px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/3dea5b9575e14e9682ab7a673cb5a5eb.png" alt="">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059878',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: 'Ken je de begrippen nog? ',
    part: null,
    questions: [],
    sequence: 4,
    time: null,
    title: 'Herhaling',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling<img class="image_resized" style="width:1139px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/cf3942f781ca48aeaf0dda6e01324d51.png" alt=""></h2>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059879',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation:
      'Zorg dat je het verschil tussen de drie herhalingen goed kent!',
    part: null,
    questions: [],
    sequence: 5,
    time: null,
    title: 'Herhaling',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling: vraag 1</h2>\n<p class="title-with-background title-with-background--question">Welk concept past bij dit symbool en deze definitie?</p>\n<figure class="image">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/5d0677e5c5a44837a6a792eefe819a2e.png" alt="">\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059930',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3><div class="OutlineElement Ltr SCXW45560279 BCX4"><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong></span>&nbsp; <span style="background-color:#ffffff;color:#000000;">Oneindige herhaling</span></p></div><div class="OutlineElement Ltr SCXW45560279 BCX4">&nbsp;</div>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337057',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100352',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Decompositie</span></p>',
          },
          {
            id: '1100353',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Algoritmisch denken</span></p>',
          },
          {
            id: '1100354',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Iteratie</span></p>',
          },
          {
            id: '1100355',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Patroonherkenning</span></p>',
          },
          {
            id: '1100356',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Sequentie</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100357',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Oneindige herhaling</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 6,
    time: null,
    title: 'Herhaling: Vraag 1',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Herhaling: vraag 2</h2>\n<p class="title-with-background title-with-background--question">Welk concept past bij dit symbool en deze definitie?</p>\n<figure class="image">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/414aed5356ae4039897ff2ba28f5b2be.png" alt="">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059931',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3><div class="OutlineElement Ltr SCXW45560279 BCX4"><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong> Decompositie</span></p></div><div class="OutlineElement Ltr SCXW45560279 BCX4">&nbsp;</div>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337058',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1100362',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Decompositie</span></p>',
          },
          {
            id: '1100363',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Algoritmisch denken</span></p>',
          },
          {
            id: '1100364',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Iteratie</span></p>',
          },
          {
            id: '1100365',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Patroonherkenning</span></p>',
          },
          {
            id: '1100366',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Sequentie</span></p>',
          },
          {
            id: '1100367',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Oneindige herhaling</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 7,
    time: null,
    title: 'Herhaling: Vraag 2',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling: vraag 3</h2>\n<p class="title-with-background title-with-background--question">Welk concept past bij dit symbool en deze definitie?</p>\n<figure class="image">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/5c85cd355eb5433bba9a0aa15c51d052.png" alt="">\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059932',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3><div class="OutlineElement Ltr SCXW45560279 BCX4"><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong> Algoritmisch denken</span></p></div><div class="OutlineElement Ltr SCXW45560279 BCX4">&nbsp;</div>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337059',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1100368',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Decompositie</span></p>',
          },
          {
            id: '1100369',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Algoritmisch denken</span></p>',
          },
          {
            id: '1100370',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Iteratie</span></p>',
          },
          {
            id: '1100371',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Patroonherkenning</span></p>',
          },
          {
            id: '1100372',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Sequentie</span></p>',
          },
          {
            id: '1100373',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Oneindige herhaling</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 8,
    time: null,
    title: 'Herhaling: Vraag 3',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling: vraag 4</h2>\n<p class="title-with-background title-with-background--question">Welk concept past bij dit symbool en deze definitie?</p>\n<figure class="image">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/609d8ade28604fe48f53f0fdace997a7.png" alt="">\n</figure>\n<p>&nbsp;</p>\n<figure class="table">\n <table style="border:3px solid transparent;">\n  <tbody>\n   <tr>\n    <td style="border:3px solid transparent;">\n     <figure class="table">\n      <table style="border:3px solid transparent;">\n       <tbody>\n        <tr>\n         <td style="border:3px solid transparent;">&nbsp;</td>\n        </tr>\n       </tbody>\n      </table>\n     </figure></td>\n   </tr>\n  </tbody>\n </table>\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059933',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3><div class="OutlineElement Ltr SCXW45560279 BCX4"><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong> Sequentie</span></p></div><div class="OutlineElement Ltr SCXW45560279 BCX4">&nbsp;</div>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337060',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100374',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Decompositie</span></p>',
          },
          {
            id: '1100375',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Algoritmisch denken</span></p>',
          },
          {
            id: '1100376',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Iteratie</span></p>',
          },
          {
            id: '1100377',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Patroonherkenning</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100378',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Sequentie</span></p>',
          },
          {
            id: '1100379',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Oneindige herhaling</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 9,
    time: null,
    title: 'Herhaling: Vraag 4',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">herhaling: vraag 5</h2>\n<p class="title-with-background title-with-background--question">Welk concept past bij dit symbool en deze definitie?</p>\n<figure class="image">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/125ce517c61e4df98e4f6778a31ebac7.png" alt="">\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059934',
    info: '<h3 class="ck5h3">Herhaling begrippen - individuele verwerking (vervolg)</h3><div class="OutlineElement Ltr SCXW45560279 BCX4"><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong> Iteratie&nbsp;</span></p></div><div class="OutlineElement Ltr SCXW45560279 BCX4">&nbsp;</div>',
    method: null,
    module: null,
    motivation: 'Dit is de laatste herhalingsvraag! Klaar om erin te vliegen?',
    part: null,
    questions: [
      {
        id: '337061',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100380',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Decompositie</span></p>',
          },
          {
            id: '1100381',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Algoritmisch denken</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100382',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Iteratie</span></p>',
          },
          {
            id: '1100383',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Patroonherkenning</span></p>',
          },
          {
            id: '1100384',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Sequentie</span></p>',
          },
          {
            id: '1100385',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Oneindige herhaling</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 10,
    time: null,
    title: 'Herhaling: Vraag 5',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">inleiding filmpje</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/f3de3115262f4f74a6f3f6cb2de1d1e1.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036943',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 11,
    time: null,
    title: 'Inleiding filmpje',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">inleidend filmpje</h2>\n<p class="title-with-background title-with-background--question">Wat moet er nog gebeuren volgens Claire?&nbsp;</p>\n<p style="text-align:center;"><iframe frameborder="0" height="70%" src="https://player.vimeo.com/video/586273476" width="100%"></iframe></p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035992',
    info: '<h3 class="ck5h3">Inleidend filmpje - klasgesprek (2 min.)</h3><p><span style="background-color:#ffffff;color:#000000;"><span>Herhaal kort de verhaallijn uit de vorige missie:</span></span></p><p><i><span>De crew is zich aan het voorbereiden op de lancering&nbsp;naar de maan. Voordat het team kan vertrekken, moet er wel nog een laatste test gebeuren...</span></i></p><p><span>Na deze bespreking&nbsp;kan je de leerlingen naar het vervolg laten kijken.</span></p><p><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:&nbsp;</strong>Een vliegsimulatie</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '336985',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100176',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Een teambuilding</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100177',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Een vliegsimulatie</span></p>',
          },
          {
            id: '1100178',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Een laatste onderhoudsbeurt</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 12,
    time: null,
    title: 'Inleidend filmpje',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Theorie</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/a2b528e45fe5439e98211cd905eed364.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036945',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 13,
    time: null,
    title: 'Theorie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">theorie</h2>\n<h3 class="ck5h3">Oneindige lus</h3>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Alle code die in de lus staat, wordt&nbsp;oneindig lang&nbsp;herhaald.</strong><img class="image_resized image-style-align-right" style="width:400px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/66e616582f2b4dffbcedbbc61ab5eca1.png" alt=""></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">In dit voorbeeld zal een sprite <strong>oneindig lang</strong>&nbsp;scripts uitvoeren.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De 4&nbsp;scripts die in de lus staan, worden daardoor oneindig lang na elkaar herhaald.&nbsp;</span></li>\n</ul>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Te onthouden over de oneindige lus</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">De opdracht wordt de hele tijd uitgevoerd tot het programma wordt stopgezet.&nbsp;</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De oneindige lus wordt ook de <strong>oneindige herhaling</strong> of de <strong>oneindige iteratie</strong> genoemd.</span></li>\n <li><span style="color:rgb(0,0,0);">Ken je de</span><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="definitie" data-modal-title="Oneindige lus" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/34fce06f35424055a32f4fe7be1f2b3a.png&quot;></figure>"> definitie </a><span style="color:rgb(0,0,0);">nog?&nbsp;</span></li>\n</ul>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035994',
    info: '<h3 class="ck5h3">Theorie&nbsp;- doceren (6&nbsp;min.)</h3><p><span>Herhaal de drie soorten lussen. Kennen de leerlingen&nbsp;de verschillen nog?&nbsp;</span></p><p><span>Bespreek en duid de definities. (Je kan de demo van de vorige les eventueel nog eens kort herhalen.)&nbsp;</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 14,
    time: null,
    title: 'Theorie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Theorie</h2>\n<h3 class="ck5h3">Eindige lus</h3>\n<p><strong>Alle code die in de lus staat, wordt&nbsp;een vast aantal keer herhaald.</strong></p>\n<ul>\n <li><img class="image_resized image-style-align-right" style="width:400px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/45702a6e3a1b4ce9b96ee1138fb6d598.png" alt=""><span style="background-color:#ffffff;color:#000000;">In dit voorbeeld zal een sprite </span><span style="background-color:rgb(255,255,255);color:#ffab19;"><strong>10&nbsp;keer</strong></span><span style="background-color:#ffffff;color:#000000;"> deze&nbsp;scripts uitvoeren.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De 3 scripts die in de lus staan, worden daardoor 10 keer na elkaar herhaald.&nbsp;</span></li>\n</ul>\n<p><strong>Te onthouden over de eindige lus</strong></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">Je kan zelf kiezen hoe vaak de opdracht in de lus&nbsp;herhaald wordt.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De eindige lus word</span><span style="background-color:rgb(255,255,255);">t ook de <strong>eindige herhaling</strong> of de <strong>eindige iteratie</strong> genoemd.</span></li>\n <li><span style="color:rgb(0,0,0);">Ken je de&nbsp;</span><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="definitie" data-modal-title="Eindige lus" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/bfa7b8beff0b461b809848be2f42e9f2.png&quot;></figure>"> definitie </a><span style="color:rgb(0,0,0);">nog?&nbsp;</span></li>\n</ul>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043253',
    info: '<h3 class="ck5h3">Theorie&nbsp;- doceren (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 15,
    time: null,
    title: 'Theorie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2"><span>theorie&nbsp;</span></h2>\n<h3 class="ck5h3">Voorwaardelijke lus</h3>\n<p><strong>Alle code die&nbsp;in de lus staat, wordt herhaald tot de conditie waar is.&nbsp;</strong></p>\n<figure class="image image_resized image-style-align-right" style="width:400px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/1834bca2c92c49759937c34bf7b83e3e.png" alt="">\n</figure>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">In dit voorbeeld zal een sprite deze scripts blijven uitvoeren tot de conditie waar is&nbsp;(dus tot de sprite bom2 raakt).</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De 3&nbsp;scripts in de lus blijven dus uitgevoerd worden tot aan die voorwaarde voldaan is.&nbsp;</span></li>\n</ul>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Te onthouden over de voorwaardelijke lus</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">De opdracht wordt uitgevoerd&nbsp;tot de conditie waar is.&nbsp;</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">D</span><span style="background-color:rgb(255,255,255);">e voorwaardelijke of conditionele lus wordt ook de <strong>voorwaardelijke </strong>of<strong> conditionele herhaling,</strong> of de <strong>voorwaardelijke </strong>of<strong> conditionele&nbsp;iteratie</strong> genoe</span><span style="background-color:#ffffff;color:#000000;">md.</span></li>\n <li><span style="color:rgb(0,0,0);">Ken je de definitie nog?&nbsp;</span></li>\n</ul>\n<figure class="table">\n <table style="border:3px solid transparent;">\n  <tbody>\n   <tr>\n    <td style="border:3px solid transparent;">&nbsp;</td>\n   </tr>\n  </tbody>\n </table>\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059838',
    info: '<h3 class="ck5h3">Theorie&nbsp;- doceren (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 16,
    time: null,
    title: 'Theorie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2>theorie</h2>\n<h3 class="ck5h3">Geneste lus<span><strong><img class="image-style-align-right" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ade7cdeb84994172be740c8d81014032.png" alt="">​</strong></span><span style="background-color:rgba(220,220,220,0.5);"><span><strong>​</strong></span></span><span><strong>​</strong></span></h3>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Wanneer je een lus in een lus plaatst, spreken we van geneste lussen.&nbsp;</strong></span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><i>Bijvoorbeeld: </i>Op de afbeelding rechts&nbsp;zie je dat de sprite oneindig lang zal blijven bewegen naar een willekeurige plaats.&nbsp;</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Hoe gebeurt dit?</strong></span></p>\n<p><span style="background-color:#ffffff;color:#000000;">De sprite zal eerst 50 keer een stap nemen om daarna te schuiven naar een willekeurige plaats. Vervolgens start het proces opnieuw, want al die scripts zitten ook in een oneindige lus.</span></p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043243',
    info: '<h3 class="ck5h3">Theorie&nbsp;- doceren (vervolg)</h3>',
    method: null,
    module: null,
    motivation: 'Een lus in een lus! Dat lust ik wel!',
    part: null,
    questions: [],
    sequence: 17,
    time: null,
    title: 'Theorie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">plugged oefening</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2a6deed67d024effbdbbd2125ed9f2e6.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036944',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 18,
    time: null,
    title: 'Plugged Oefening',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2>opdracht 1: eerste testvlucht</h2>\n<h3 class="ck5h3">Claire heeft een testvlucht ingepland</h3>\n<p style="text-align:center;"><span style="background-color:#ffffff;color:#000000;">Help jij haar om de asteroïden te programmeren en alle snufjes van het schip uit te testen?</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="500px" name="" src="https://codefeverpublic.blob.core.windows.net/public-content/videos/00f98e86db66499c97c43dd372ac6b94.mp4" title="" width="800px">&nbsp;</iframe>&nbsp;</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035995',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - klassikale verwerking (10&nbsp;min.)</h3><p><span>Deze stappen zijn erg belangrijk bij computationeel denken. We willen de leerlingen stimuleren om bewust na te denken over de&nbsp;deelstappen waarin ze hun spel willen opsplitsen.&nbsp;</span></p><p><span>Laat de leerlingen dus kijken naar dit filmpje en noteren wat ze allemaal zien gebeuren. (Zie volgende slide.)&nbsp;Met de intro-animatie hoeven ze geen rekening te houden.</span></p><p><span><strong>Dit zijn mogelijke antwoorden:&nbsp;</strong></span></p><p><span><strong>1. De asteroïdengordels</strong></span></p><ul><li><span>Asteroïdengordels bewegen steeds naar boven en beneden.</span></li><li><span>Sommige asteroïdengordels gaan verder naar boven en beneden.</span></li><li><span>Sommige asteroïdengordels gaan eerst naar boven, andere&nbsp;gaan eerst naar beneden.</span></li></ul><p><span><strong>2. COSMOS-1</strong></span></p><ul><li><span>Als de COSMOS-1 de asteroïdengordels raakt, moet hij opnieuw beginnen.</span></li><li><span>Je kan de COSMOS-1 naar omhoog laten gaan door op de spatiebalk te drukken.</span></li><li><span>Je kan de COSMOS-1 naar links of naar rechts laten gaan door respectievelijk op pijltje links of rechts te drukken.</span></li></ul>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 19,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">opdracht 1: eerste testvlucht</h2> \n<h3 class="ck5h3">Op de vorige slide zag je een sneak peek van het spel dat je zal programmeren</h3> \n<h3 style="text-align:center;">&nbsp;</h3> \n<p class="title-with-background title-with-background--question">Welke deelstappen merk&nbsp;jij op in het filmpje?&nbsp;Noteer de stappen in het invoerveld.</p> \n<p style="text-align:center;">&nbsp;</p> \n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p><span style="background-color:#ffffff;color:#000000;">We formuleren de vraag even op andere manieren:</span></p><p><span style="background-color:#ffffff;color:#000000;">Wat is er allemaal geprogrammeerd?&nbsp;</span></p><p><span style="background-color:#ffffff;color:#000000;">Welke regels zou de programmeur in dit filmpje hebben gevolgd?&nbsp;</span></p><p><span style="background-color:#ffffff;color:#000000;">Uit welke onderdelen bestaat het spel?</span></p>',
        id: '2336',
        title: 'Niet helemaal mee?',
      },
    ],
    id: '2036527',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - klassikale verwerking (vervolg)</h3><p><span style="background-color:#ffffff;color:#000000;"><strong>Dit zijn de mogelijke&nbsp;deelstappen:&nbsp;</strong></span></p><p><span style="background-color:#ffffff;color:#000000;"><strong>1. De asteroïdengordels</strong></span></p><p><span style="background-color:#ffffff;color:#000000;">De asteroïdengordels bewegen steeds naar boven en beneden.</span></p><p><span style="background-color:#ffffff;color:#000000;">Sommige asteroïdengordels gaan verder naar beneden en boven dan andere.</span></p><p><span style="background-color:#ffffff;color:#000000;">Sommige asteroïdengordels gaan eerst naar boven, andere&nbsp;gaan eerst&nbsp;naar beneden.</span></p><p><span style="background-color:#ffffff;color:#000000;"><strong>2. COSMOS-1</strong></span></p><p><span style="background-color:#ffffff;color:#000000;">Als de COSMOS-1 de asteroïdengordels raakt, moet hij opnieuw beginnen.</span></p><p><span style="background-color:#ffffff;color:#000000;">COSMOS-1 kan naar omhoog gaan door op de spatiebalk te drukken.</span></p><p><span style="background-color:#ffffff;color:#000000;">COSMOS-1 kan naar links of naar rechts gaan door respectievelijk&nbsp;op pijltje links of rechts te drukken.</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '331314',
        placeholder: 'Typ hier jouw antwoord.',
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution:
          'Asteroïdengordels bewegen steeds naar boven en beneden.\n\nSommige asteroïdengordels gaan verder naar beneden en boven dan anderen.\n\nSommige asteroïdengordels starten met naar boven te gaan, anderen starten met naar beneden te gaan.\n\nAls de COSMOS-1 de asteroïdengordels raakt, dan moet hij opnieuw beginnen.\n\nCOSMOS-1 kan naar omhoog gaan door op de spatiebalk te drukken.\n\nCOSMOS-1 kan naar links of naar rechts gaan door op pijltje naar links of naar rechts te drukken.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 20,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">opdracht 1: eerste testvlucht</h2>\n<h3 class="ck5h3">Dit zijn de mogelijke deelstappen</h3>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>1. De asteroïdengordels</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">De asteroïdengordels bewegen steeds naar boven en beneden.</span><img class="image_resized image-style-align-right" style="width:506px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e82e77aeae6e4ba5ade3553fd8b7d9a3.png" alt=""></li>\n <li><span style="background-color:#ffffff;color:#000000;">Sommige asteroïdengordels gaan verder naar beneden en boven dan andere.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">Sommige asteroïdengordels gaan eerst naar boven, andere&nbsp;gaan eerst&nbsp;naar beneden.</span></li>\n</ul>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>2. COSMOS-1</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">Als de COSMOS-1 de asteroïdengordels raakt, moet hij opnieuw beginnen.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">COSMOS-1 kan naar omhoog gaan door op de spatiebalk te drukken.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">COSMOS-1 kan naar links of naar rechts gaan door respectievelijk&nbsp;op pijltje links of rechts te drukken.</span></li>\n</ul>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036528',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - klassikale verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 21,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">opdracht 1: eerste testvlucht</h2>\n<h3 class="ck5h3">In deze oefening komen de volgende scripts voor het eerst aan bod!</h3>\n<figure class="table" style="float:left;width:1107px;">\n <table style="border-style:solid;">\n  <tbody>\n   <tr>\n    <td style="width:319px;"><p style="text-align:center;"><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/03d811ae2ffc88092f90840d50a3b82cbafbd207ac399b2074655babe9c72ed5.png" alt=""></p><p style="text-align:center;"><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e0835ae49fde2f14f3e8d31fdcc81878a4abef9c9f4600504ad61de3d6af2df1.png" alt=""></p></td>\n    <td style="width:778px;"><span style="background-color:#ffffff;color:#000000;">Het script&nbsp;<strong>richt naar</strong> gebruik je om de sprite naar een bepaalde richting&nbsp;</span><br><span style="background-color:#ffffff;color:#000000;">te laten kijken. In dit spel zullen we de sprite&nbsp;naar boven (0 graden) of naar&nbsp;</span><br><span style="background-color:#ffffff;color:#000000;">beneden (180 graden) richten.</span></td>\n   </tr>\n   <tr>\n    <td style="width:319px;"><p style="text-align:center;"><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/b58f59a66a554fe881b8b2286a7f95df.png" alt=""></p></td>\n    <td style="width:778px;"><span style="background-color:#ffffff;color:#000000;">Klik op het getal en er&nbsp;komt een pijl op een cirkel&nbsp;tevoorschijn. Het pijltje&nbsp;</span><br><span style="background-color:#ffffff;color:#000000;">wijst nu naar rechts. Duid zelf aan in Scratch of de sprite naar boven of naar&nbsp;</span><br><span style="background-color:#ffffff;color:#000000;">beneden moet kijken.</span></td>\n   </tr>\n  </tbody>\n </table>\n</figure>\n<p>&nbsp;</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036529',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - klassikale verwerking (vervolg)</h3><p><span>Bespreek met de leerlingen de nieuwe scripts, zodat&nbsp;ze de blokjes meteen kunnen inzetten tijdens de nieuwe programmeeroefening.&nbsp;</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 22,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">opdracht 1: eerste testvlucht</h2>\n<p class="SlideViewer__Badge tip"><img class="image-style-align-right" src="https://codefeverpublic.blob.core.windows.net/public-content/images/8f081e48f2b2411b8db4982c4b91ead0.png" alt=""><strong>TIP 1</strong><br>Soms kan je opeens andere code zien&nbsp;staan. Dat gebeurt wanneer je een andere sprite geselecteerd hebt. Om het stuk code te zien dat je hebt geprogrammeerd, moet je&nbsp;de juiste sprite selecteren.&nbsp;Dat doe je door op de sprite in het spriteoverzicht te klikken. De sprite krijgt dan een blauw kader.</p>\n<p class="SlideViewer__Badge tip"><strong>TIP 2</strong><br>Wanneer je&nbsp;een sprite per ongeluk verwijdert door op het vuilnisbakje te klikken, zal je opnieuw moeten beginnen... Een verwijderde sprite kan niet meer teruggezet worden in Scratch.</p>\n<p class="SlideViewer__Badge tip"><strong>TIP 3</strong><br>Je kan de&nbsp;digitale co-teacher starten door op controleren te klikken. Je krijgt dan de feedback van de digitale co-teacher te zien.&nbsp;</p>\n<p class="SlideViewer__Badge tip"><strong>TIP 4</strong><br>Deze<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="instructievideo" data-modal-title="Instructievideo" data-modal-size="M" data-modal-content="<p><iframe src=&quot;https://player.vimeo.com/video/693958739?h=3ec40c960c&quot; width=&quot;640&quot; height=&quot;564&quot; frameborder=&quot;0&quot; allow=&quot;autoplay; fullscreen&quot; allowfullscreen=&quot;&quot;></iframe></p>"> instructievideo </a>kan jou ook extra op weg helpen, als je vergeten bent hoe alles werkt in Scratch.&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059745',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - klassikale verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 23,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2>opdracht 1: eerste testvlucht</h2>\n<h3 class="ck5h3">Deel 1</h3>\n<p>Het ruimteschip staat klaar voor de start en kan bewegen met het pijltje naar links of rechts&nbsp;en de spatiebalk.&nbsp; <span style="background-color:#ffffff;color:#000000;">Test je dat al eens uit? Je&nbsp;moet&nbsp;er daarna voor zorgen dat de gordels kunnen bewegen. Start&nbsp;bij <strong>gordel 1</strong>.</span><strong><img class="image_resized image-style-align-right" style="width:300px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/8bd3cfc5225a4f56b3514e50050c9b69.png" alt=""></strong></p>\n<p><span style="background-color:#ffffff;color:#000000;">Nadat het start-signaal ontvangen is en de gordel op zijn plek staat&nbsp;(die&nbsp;is al voor je klaargezet), moet de gordel bewegen.&nbsp;</span></p>\n<p><span style="background-color:#ffffff;color:#000000;">De gordel moet </span><span style="background-color:rgb(255,255,255);color:#ffab19;"><strong>heel het spelletje lang</strong> </span><span style="background-color:#ffffff;color:#000000;">het volgende doen:</span></p>\n<ul>\n <li><span style="background-color:rgb(255,255,255);color:#4c97ff;"><strong>naar boven richten</strong></span><span style="background-color:#ffffff;color:#000000;">,</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">bewegen door </span><span style="background-color:#ffffff;color:#ffab19;"><strong>25 keer </strong></span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1 stap te nemen</strong></span><span style="background-color:#ffffff;color:#000000;">,</span></li>\n <li><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar beneden richten</strong></span><span style="background-color:#ffffff;color:#000000;">,</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">bewegen door </span><span style="background-color:#ffffff;color:#ffab19;"><strong>25 keer </strong></span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1 stap te nemen.</strong></span></li>\n</ul>\n<p><span style="background-color:#ffffff;color:#000000;">Hop hop, naar de oefen</span>ing!&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ExerciseLink" data-exercise-id="232560" data-studio-link-id="436" data-version-id="232904">Eerste Testvlucht</a></p>\n<p><span style="background-color:#ffffff;color:#000000;">Klaar? Op de volgende slide zie je wat de andere gordels moeten doen.&nbsp;</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035996',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - individuele verwerking (20 min.)</h3><p><span style="background-color:#ffffff;color:#000000;">Vanaf nu kunnen de leerlingen individueel aan de slag gaan. Ze programmeren alle asteroïdengordels.</span></p><p style="margin-left:0;"><span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">Het is belangrijk dat de leerlingen uit de&nbsp;slides halen welke blokken ze moeten gebruiken. Dat kunnen ze zien aan de kleuren in de slide.&nbsp;</span></p><p><span><strong>Een mogelijke oplossing:&nbsp;</strong></span></p><p><a class="SlideViewer__StyledButton SlideViewer__ExerciseLink" data-studio-link-id="225" versionid="232653">Open oefening</a></p><p class="SlideViewer__Badge tip"><strong>TIP</strong><br>Leerlingen die snel klaar zijn, kunnen aan de slag met de extra uitdaging. De oranje knop in de volgende slide&nbsp;brengt hen daar rechtstreeks naartoe. Moeten ze weer even meevolgen? Dan kunnen ze makkelijk terugkeren naar de klasslides.&nbsp;</p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 24,
    time: null,
    title: 'Opdracht 1: Eerste testvlucht',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">opdracht 1: eerste testvlucht</h2>\n<h3 class="ck5h3">Deel 2<strong><img class="image_resized image-style-align-right" style="width:300px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/8bd3cfc5225a4f56b3514e50050c9b69.png" alt=""></strong></h3>\n<p><span style="background-color:#ffffff;color:#000000;">Ze moeten vaak <strong>ongeveer</strong>&nbsp;<strong>hetzelfde</strong> doen <strong>als</strong> <strong>gordel 1</strong>, maar de richting en het aantal stappen kan variëren.</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Gordel 2&nbsp;</strong>moet eerst </span><span style="background-color:rgb(255,255,255);color:#4c97ff;"><strong>naar boven richten</strong></span><span style="background-color:#ffffff;color:#000000;">&nbsp;en daarna&nbsp;</span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar beneden</strong></span><span style="background-color:#ffffff;color:#000000;">. Telkens&nbsp;moet&nbsp;hij&nbsp;</span><span style="background-color:#ffffff;color:rgb(255,171,25);"><strong>30</strong>&nbsp;<strong>keer</strong></span><span style="background-color:#ffffff;color:#000000;"> </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1&nbsp;stap&nbsp;nemen</strong></span><span style="background-color:#ffffff;color:#000000;">.</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Gordel 3&nbsp;</strong>moet eerst </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar beneden richten</strong></span><span style="background-color:#ffffff;color:#000000;"> en daarna&nbsp;</span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar boven</strong></span><span style="background-color:#ffffff;color:#000000;">. Telkens&nbsp;moet&nbsp;hij&nbsp;</span><span style="background-color:#ffffff;color:rgb(255,171,25);"><strong>30&nbsp;keer</strong></span><span style="background-color:#ffffff;color:#000000;"><strong> </strong></span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1&nbsp;stap&nbsp;nemen</strong></span><span style="background-color:#ffffff;color:#000000;">.</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Gordel 4&nbsp;</strong>moet eerst </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar beneden richten</strong></span><span style="background-color:#ffffff;color:#000000;"> en daarna&nbsp;</span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar boven</strong></span><span style="background-color:#ffffff;color:#000000;">. Telkens&nbsp;moet&nbsp;hij&nbsp;</span><span style="background-color:#ffffff;color:rgb(255,171,25);"><strong>25&nbsp;keer</strong></span><span style="background-color:#ffffff;color:#000000;"> </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1&nbsp;stap&nbsp;nemen</strong></span><span style="background-color:#ffffff;color:#000000;">.</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Gordel 5&nbsp;</strong>moet eerst </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar beneden richten</strong></span><span style="background-color:#ffffff;color:#000000;"> en daarna&nbsp;</span><span style="background-color:#ffffff;color:#4c97ff;"><strong>naar boven</strong></span><span style="background-color:#ffffff;color:#000000;">. Telkens&nbsp;moet&nbsp;hij&nbsp;</span><span style="background-color:#ffffff;color:rgb(255,171,25);"><strong>40&nbsp;keer</strong></span><span style="background-color:#ffffff;color:#000000;"> </span><span style="background-color:#ffffff;color:#4c97ff;"><strong>1&nbsp;stap&nbsp;nemen</strong></span><span style="background-color:#ffffff;color:#000000;">.</span></p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p><a class="SlideViewer__StyledButton SlideViewer__SlideLink" data-target-slide-id="2036477" false=""> Klik hier! </a></p>\n',
        id: '2332',
        title: 'Klaar voor een extra uitdaging?',
      },
    ],
    id: '2036010',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: 'De laatste stapjes!',
    part: null,
    questions: [],
    sequence: 25,
    time: null,
    title: 'Eerste Testvlucht: deel 2',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">oplossing</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2d605d30be554644850bd5f840b745a0.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043248',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 26,
    time: null,
    title: 'Oplossing',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Oplossingen voor ‘testvlucht’</h2>\n<figure class="table" style="width:100%;">\n <table style="border-style:solid;">\n  <thead>\n   <tr>\n    <th>Gordel 1</th>\n    <th>Gordel 2</th>\n    <th>Gordel 3</th>\n    <th>Gordel 4</th>\n    <th>Gordel 5</th>\n   </tr>\n  </thead>\n  <tbody>\n   <tr>\n    <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 1" data-modal-title="Oplossing 1" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/0fb7717ad38049eeb29c40a28910b076.png&quot;></figure>">&nbsp;Oplossing 1&nbsp;</a>&nbsp;</td>\n    <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 2" data-modal-title="Oplossing 2" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/2ff3822c8c724111a9eb58de25ec2d23.png&quot;></figure>">&nbsp;Oplossing 2&nbsp;</a>&nbsp;</td>\n    <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 3" data-modal-title="Oplossing 3" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/b300fd552f8e407981aa4eb075a8158e.png&quot;></figure>">&nbsp;Oplossing 3&nbsp;</a>&nbsp;</td>\n    <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 4" data-modal-title="Oplossing 4" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/45e09c6de56643f4ba0d8a95425a09ad.png&quot;></figure>">&nbsp;Oplossing 4&nbsp;</a>&nbsp;</td>\n    <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 5" data-modal-title="Oplossing 5" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/07dec240bf26472ead2186a5aceeeb69.png&quot;></figure>">&nbsp;Oplossing 5&nbsp;</a>&nbsp;</td>\n   </tr>\n  </tbody>\n </table>\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043242',
    info: '<h3 class="ck5h3">Opdracht 1: Eerste testvlucht - oplossing</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 27,
    time: null,
    title: "Oplossingen voor 'Eerste Testvlucht'",
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">quiz</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/3ec6e4ee961e44e0a91d7e0184a6de40.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036946',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 28,
    time: null,
    title: 'Quiz',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 1</h2>\n<p class="title-with-background title-with-background--question">Hoe schrijf je deze code korter?</p>\n<figure class="image">\n <img style="aspect-ratio:233/634;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/eca577b802784b629dc92cf5aca5a1dc.png" width="233" height="634">\n</figure>\n<p><span>​</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059938',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong>&nbsp;B</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337064',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100393',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ed54adc1e1fc4f7280a85f1531d6cc34.png" alt=""></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100394',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/da17d2dd95df4cd88c79706f4f7cb298.png" alt=""></p>',
          },
          {
            id: '1100395',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/9b5ae537eaf34855a3297b90385d2ff2.png" alt=""></p>',
          },
          {
            id: '1100396',
            numbering: null,
            value: '<p>Geen van de gegeven oplossingen is juist</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 30,
    time: null,
    title: 'Quiz: Vraag 1',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 2</h2>\n<p class="title-with-background title-with-background--question">Ik wil dat Pedro naar het schip geraakt. Welke code past het best?&nbsp;</p>\n<figure class="image image_resized" style="width:760px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/c5849135fe0a4c878fbd4f7f54debf09.png" alt="">\n</figure>\n<p><span style="background-color:rgba(220,220,220,0.5);"><span><img alt=""></span></span><span>​​</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059935',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong>&nbsp;</span><span>B</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337062',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100386',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/94e5ce7c0f42460ab5eb18498b84238e.png" alt=""></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100387',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2676fe5bd1b54915bdfd7a32907349e2.png" alt=""></p>',
          },
          {
            id: '1100388',
            numbering: null,
            value:
              '<p><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/af1a05a7b1994275a716a0dc619f966c.png" alt=""></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 31,
    time: null,
    title: 'Quiz: Vraag 2',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 3</h2>\n<p class="title-with-background title-with-background--question">Welke is de oneindige lus?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059982',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong> C</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337084',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100456',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:253px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/338c195e8812b7c4f80f6e74726b987a9bd7a5b034f0425e6ece70309067e8b4.png" alt="">\n</figure>\n<p>&nbsp;</p>',
          },
          {
            id: '1100457',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:253px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/87313f5bb11efcf3a7a93a4dedc004cbc7020f9517f5af94900d77c0bfcbb672.png" alt="">\n</figure>\n<p>&nbsp;</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100458',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:253px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/e0fee90f9b8af31ac3c16da57734d5fec4269382064ac3ba95013f160ce0473f.png" alt="">\n</figure>\n<p>&nbsp;</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 32,
    time: null,
    title: 'Quiz: Vraag 3',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 4</h2>\n<p class="title-with-background title-with-background--question">Welke uitspraak is fout?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059983',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong>&nbsp;</span><span>B</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337085',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100459',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Wanneer de computer een lus leest, voert hij de code in de lus van boven naar onderen uit. Zodra hij alle code in de lus gelezen heeft, gaat hij weer naar boven om de code opnieuw te lezen. Dat doet hij bij een eindige lus een vast aantal keer.</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100460',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">In een lus maakt de sequentie (de volgorde van scripts) niet meer uit.</span></p>',
          },
          {
            id: '1100461',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De oneindige lus vind je in Scratch terug bij \'besturen\'.</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 33,
    time: null,
    title: 'Quiz: Vraag 4',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 5</h2>\n<p class="title-with-background title-with-background--question">Interpreteer de code. Wat gebeurt&nbsp;er wanneer de spatiebalk ingedrukt is?</p>\n<figure class="image">\n <img style="aspect-ratio:273/555;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/61ca06938a6b475c94e50f38feb47a59.png" width="273" height="555">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059937',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong>&nbsp;D</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337065',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100397',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">Het programma wordt uitgevoerd.&nbsp;</span></p>',
          },
          {
            id: '1100398',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite wordt klaargezet en neemt 16 keer een stap vooruit. Tussendoor draait hij naar links of naar rechts.&nbsp;</span></p>',
          },
          {
            id: '1100399',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite zet eerst 4 stappen, draait&nbsp;naar rechts om daarna&nbsp;nog 9 stappen te nemen. Na een draai naar links zet de sprite nog 3 laatste stappen vooruit.&nbsp;</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100400',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite wordt eerst klaargezet. Daarna zet hij 4 keer een stap vooruit, draait hij naar rechts om dan nog 9 keer een&nbsp;stap vooruit&nbsp;te nemen. Na een draai naar links zet de sprite nog 3 keer een stap vooruit.&nbsp;</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 34,
    time: null,
    title: 'Quiz: Vraag 5',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">quiz: vraag 6</h2>\n<p class="title-with-background title-with-background--question" style="text-align:center;">Interpreteer de code. Wat gebeurt er&nbsp;wanneer het signaal voor start ontvangen wordt?</p>\n<figure class="image">\n <img style="aspect-ratio:295/409;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/834a590c897b4b088985a434d13f82bd.png" width="295" height="409">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059939',
    info: '<h3 class="ck5h3">Vastzetting leerstof - individuele verwerking (vervolg)</h3><p class="Paragraph SCXW45560279 BCX4" paraeid="{deb80e87-323c-4ce5-920c-ccabbfaee97d}{39}" paraid="27"><span style="background-color:#ffffff;color:#000000;"><strong>Oplossing:</strong>&nbsp;</span><span>B</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '337066',
        maxSelectableAnswers: 1,
        questionAnswersMultipleChoice: [
          {
            id: '1100401',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite verschijnt en wordt kleiner gemaakt. Daarna herhaalt de sprite 10 keer de volgende code: de sprite richt naar de muisaanwijzer, neemt 5 stappen, wordt groter of kleiner wanneer die een object raakt en past zijn snelheid aan.&nbsp;</span></p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1100402',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite verschijnt en wordt kleiner gemaakt. Daarna herhaalt de sprite oneindig lang de volgende code: de sprite richt naar de muisaanwijzer, neemt 5 stappen, wordt groter of kleiner wanneer die een object raakt en past zijn snelheid aan.&nbsp;</span></p>',
          },
          {
            id: '1100403',
            numbering: null,
            value:
              '<p><span style="background-color:#ffffff;color:#000000;font-family:var(--default-font);font-size:18px;font-weight:normal;padding:0 0;">De sprite verschijnt en wordt groter&nbsp;gemaakt. Daarna herhaalt de sprite oneindig lang de volgende code: de sprite richt naar de muisaanwijzer, neemt 6&nbsp;stappen, wordt groter of kleiner wanneer die een object raakt en past zijn snelheid niet aan.&nbsp;</span></p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 35,
    time: null,
    title: 'Quiz: Vraag 6',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">concepten</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/84bd3cd44eb64a8c879a09f3b4bd8e2e.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2059964',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 36,
    time: null,
    title: 'Concepten',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Concepten</h2>\n<figure class="image image_resized" style="width:1139px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/3dea5b9575e14e9682ab7a673cb5a5eb.png" alt="">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035997',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 37,
    time: null,
    title: 'Concepten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Concepten</h2>\n<figure class="image image_resized" style="width:1013px;">\n <img src="https://codefeverpublic.blob.core.windows.net/public-content/images/cf3942f781ca48aeaf0dda6e01324d51.png" alt="">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2035998',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 38,
    time: null,
    title: 'Concepten',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">afsluitend filmpje</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/f9e005da15a0465f84e8ed4925e622f8.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036950',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 39,
    time: null,
    title: 'Afsluitend filmpje',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">afsluitend filmpje</h2>\n<p style="text-align:center;"><iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="500px" name="" src="https://codefeverpublic.blob.core.windows.net/public-content/videos/de7d72efc8d64100baacee82316f4d0a.mp4" title="" width="800px">&nbsp;</iframe></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2061783',
    info: '<h3 class="ck5h3">Afsluitend filmpje - Klasgesprek (2 min.)</h3><p><span>Laat de leerlingen het afsluitende filmpje bekijken zodat ze mee blijven met&nbsp;het verhaal.&nbsp;</span></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 40,
    time: null,
    title: 'Afsluitend filmpje',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div>\n <h2 class="dotted-in-editor">leerwijzer - missie 7</h2>\n <div class="learnContainer">\n  <div class="mainContent dotted-in-editor">\n   <h3>Download hier de leerwijzer van deze les:</h3>\n   <div class="check-list">\n    <p><a class="SlideViewer__StyledButton SlideViewer__DownloadLink" download-file-name="IT&amp;ME1_ComputationeelDenken2_L2_Missie7_Leerwijzer" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/1b57006b17d84ffeaf46d9f423576482.pdf">Download leerwijzer</a></p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n   </div>\n   <p>&nbsp;</p>\n   <div class="ftrprfLogo">\n    &nbsp;\n   </div>\n  </div>\n  <div class="dotted-in-editor imagePlaceholder">\n   <span><img src="https://codefeverpublic.blob.core.windows.net/public-content/images/ccab545807814205b8ad7edc30ff00ee.jpg" alt=""></span>\n  </div>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2105320',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 41,
    time: null,
    title: 'Leerwijzer',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">plugged oefening</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2a6deed67d024effbdbbd2125ed9f2e6.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036952',
    info: null,
    method: null,
    module: null,
    motivation: 'Nog wat tijd over? Hier een extra oefening!',
    part: null,
    questions: [],
    sequence: 42,
    time: null,
    title: 'Plugged oefening',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<p><iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="100%" name="undefined" src="https://player.vimeo.com/video/1048572300" title="" width="100%">&nbsp;</iframe></p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p><a class="SlideViewer__StyledButton SlideViewer__SlideLink" data-target-slide-id="2036010" false="">Klik hier!</a></p>',
        id: '2335',
        title: 'Terug naar opdracht 1',
      },
    ],
    id: '2036477',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- klasgesprek (1&nbsp;min.)</h3><p><span>Laat de leerlingen even naar dit filmpje kijken zodat&nbsp;ze mee zijn met het verhaal wanneer ze naar de volgende oefening overgaan.</span></p><p>&nbsp;</p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 43,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Op de vorige slide zag je een sneak peek van het spel dat je zal programmeren.&nbsp;</h3>\n<p class="title-with-background title-with-background--question" style="text-align:center;">Welke deelstappen merk&nbsp;jij op in het filmpje?&nbsp;Noteer de stappen in het invoerveld.</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p><span style="background-color:#ffffff;color:#000000;">We formuleren de vraag even op andere manieren:</span></p><p><span style="background-color:#ffffff;color:#000000;">Wat is er allemaal geprogrammeerd?&nbsp;</span></p><p><span style="background-color:#ffffff;color:#000000;">Welke regels zou de programmeur in dit filmpje hebben gevolgd?&nbsp;</span></p><p><span style="background-color:#ffffff;color:#000000;">Uit welke onderdelen bestaat het spel?</span></p>',
        id: '2330',
        title: 'Niet helemaal mee?',
      },
    ],
    id: '2036559',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (?&nbsp;min.)</h3><p><span style="background-color:#ffffff;color:#000000;">Vanaf nu kunnen de leerlingen individueel aan de slag gaan. Ze programmeren RONN-1E, de elektriciteitskabel, de proefbuis en de kast.</span></p><p style="margin-left:0;"><span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">Het is belangrijk dat de leerlingen uit de&nbsp;slides halen welke blokken ze moeten gebruiken. Dat kunnen ze zien aan de kleuren van de tekst in de slide.&nbsp;</span></p><p><span style="background-color:#ffffff;color:#000000;"><strong>Dit zijn de mogelijke deelstappen:</strong></span></p><p><span style="background-color:#ffffff;color:#000000;"><strong>1. RONN-1E</strong></span></p><ul><li><span style="background-color:#ffffff;color:#000000;">RONN-1E kan bewegen met de pijltjes.</span></li></ul><p><span style="background-color:#ffffff;color:#000000;"><strong>2. De hindernissen</strong></span></p><ul><li><span style="background-color:#ffffff;color:#000000;">De proefbuis stapt eerst naar links en daarna weer naar rechts. Na een vast aantal stappen ontploft hij.</span></li><li><span style="background-color:#ffffff;color:#000000;">De elektriciteitsdraad gaat steeds van boven naar beneden en terug.</span></li><li><span style="background-color:#ffffff;color:#000000;">De kast valt van boven naar beneden. Na een vast aantal stappen stopt de kast.&nbsp;</span></li><li><span style="background-color:#ffffff;color:#000000;">De laser blijft weerkaatsen tot hij de rand raakt.</span></li></ul>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '331329',
        placeholder: 'Typ hier jouw antwoord.',
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution:
          'RONN-1E kan bewegen met de pijltjes.\n\nDe proefbuis stapt eerst naar links en daarna naar rechts. Na een vast aantal stappen ontploft hij.\n\nDe elektriciteitsdraad gaat steeds van boven naar beneden en terug.\n\nDe kast valt van boven naar beneden. Na een vast aantal stappen stopt de kast. \nSommige asteroïdengordels gaan verder naar beneden en boven dan anderen.\n\nSommige asteroïdengordels starten met naar boven te gaan, andere starten met met naar beneden te gaan.\n\nAls de COSMOS-1 de asteroïdengordels raakt, dan moet hij opnieuw beginnen.\n\nCOSMOS-1 kan naar omhoog gaan door op de spatiebalk te drukken.\n\nCOSMOS-1 kan naar links of naar rechts gaan door op pijltje naar links of naar rechts te drukken.\n\nDe laser blijft weerkaatsten tot hij de rand raakt.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 44,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2>extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Dit zijn de mogelijke deelstappen</h3>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>1. RONN-1E</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">RONN-1E kan bewegen met de pijltjes.</span></li>\n</ul>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>2. De hindernissen</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">De proefbuis stapt eerst naar links en daarna weer naar rechts. Na een vast aantal stappen ontploft hij.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De elektriciteitsdraad gaat steeds van boven naar beneden en terug.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De kast valt van boven naar beneden. Na een vast aantal stappen stopt de kast.&nbsp;</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">De laser blijft weerkaatsen tot hij de rand raakt.</span></li>\n</ul>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036560',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 45,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Help je mee om&nbsp;R0NN-1E de startknop te laten bereiken?</h3>\n<p><span style="color:rgb(0,0,0);">Open oefening: </span><a class="SlideViewer__StyledButton SlideViewer__ExerciseLink" data-exercise-id="232570" data-studio-link-id="435" data-version-id="232910">Zet de lasers uit</a></p>\n<p><span style="background-color:#ffffff;color:#000000;"><strong>Dan moet je&nbsp;eerst...</strong></span></p>\n<ul>\n <li><span style="background-color:#ffffff;color:#000000;">R0NN-1E,</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">de elektriciteitsdraad,</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">de proefbuis en</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">de kast</span>&nbsp;programmeren.&nbsp;</li>\n</ul>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036478',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3><p><span><strong>Mogelijke oplossing:&nbsp;</strong></span></p><p><a class="SlideViewer__StyledButton SlideViewer__ExerciseLink" data-studio-link-id="303" versionid="232703">Open oefening</a></p>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 46,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit ',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">R0NN-1E<span style="background-color:#ffffff;color:#000000;"><strong><img class="image_resized image-style-align-right" style="width:400px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e2a2e928a2074893a52104dfd8a19647.png" alt=""></strong></span></h3>\n<ul>\n <li>Als pijltje naar links is ingedrukt,</li>\n <li>dan richt R0NN-1E naar links</li>\n <li>en neemt hij 5 stappen.</li>\n</ul>\n<p class="SlideViewer__Badge warning"><strong>LET OP</strong><br>Doe dat ook voor de andere drie pijltjes!</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036490',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 47,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Elektriciteitsdraad<span style="background-color:#ffffff;color:#000000;"><strong><img class="image_resized image-style-align-right" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/62f9ac97ba1042039dd0bd3f50e6039d.png" alt=""></strong></span></h3>\n<p>Wanneer het signaal start wordt ontvangen,&nbsp;</p>\n<p style="margin-left:40px;">dan verschijnt de draad.</p>\n<p>De elektriciteitsdraad zal&nbsp;oneindig lang</p>\n<p style="margin-left:40px;">volgend uiterlijk kiezen en</p>\n<p style="margin-left:40px;">0.01 seconde wachten</p>\n<p class="SlideViewer__Badge info"><strong>WEETJE</strong><br>De elektriciteitsdraad heeft meerdere uiterlijken die steeds wisselen. Daardoor lijkt het alsof de draad echt beweegt. Dat is net zoals in de vroegere tekenfilms.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036484',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 48,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Proefbuis</h3>\n<p>Wanneer het signaal start wordt ontvangen, <img class="image_resized image-style-align-right" style="width:400px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/b2a0b47a58ca4fcfaf0532b20a6789ad.png" alt=""></p>\n<p><span style="background-color:#ffffff;color:#000000;">da</span>n wordt de proefbuis klaargezet.</p>\n<p>Vervolgens gaat hij 60 keer&nbsp;</p>\n<p style="margin-left:40px;">naar links richten</p>\n<p style="margin-left:40px;">en 6 stappen nemen.</p>\n<p>Daarna gaat hij 50 keer&nbsp;</p>\n<p style="margin-left:40px;">naar rechts richten</p>\n<p style="margin-left:40px;">en 5 stappen nemen.</p>\n<p>Als laatste ontploft de proefbuis.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036483',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 49,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">extra opdracht: zet de lasers uit</h2>\n<h3 class="ck5h3">Kast</h3>\n<p>Wanneer het signaal start wordt ontvangen, <img class="image_resized image-style-align-right" style="width:400px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/fe2a40981d1946aebec8315d50ef81ad.png" alt=""></p>\n<p><span style="background-color:#ffffff;color:#000000;">dan wordt de</span> kast klaargezet.</p>\n<p>Vervolgens moet&nbsp;hij&nbsp;16&nbsp;keer&nbsp;</p>\n<p>4&nbsp;stappen nemen.<br><span>&nbsp;</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2036482',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- individuele verwerking (vervolg)</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 50,
    time: null,
    title: 'Extra opdracht: Zet de lasers uit',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">oplossing</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2d605d30be554644850bd5f840b745a0.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2105323',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 51,
    time: null,
    title: 'Oplossing',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Extra opdracht: oplossing</h2>\n<figure class="table" style="width:100%;">\n <table style="border-style:groove;">\n  <thead>\n   <tr>\n    <th style="text-align:center;">RONN-1E</th>\n   </tr>\n  </thead>\n  <tbody>\n   <tr>\n    <td><p style="text-align:center;"><img src="https://codefeverpublic.blob.core.windows.net/public-content/images/159c0dcffe744ee88aff633ecad04c6e.png" alt=""></p></td>\n   </tr>\n  </tbody>\n </table>\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043244',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- oplossing</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 52,
    time: null,
    title: 'Extra opdracht: Oplossing',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">oplossing</h2>\n<figure class="table" style="width:100%;">\n <table style="border-style:solid;">\n  <thead>\n   <tr>\n    <th style="width:33%;">Elektriciteitskabel</th>\n    <th style="width:33%;">Proefbuis</th>\n    <th style="width:33%;">Kast</th>\n   </tr>\n  </thead>\n  <tbody>\n   <tr>\n    <td style="width:33%;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 1" data-modal-title="Oplossing 1" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/6ae8589a403a46d28e8326bfe00d3dca.png&quot;></figure>">&nbsp;Oplossing 1&nbsp;</a>&nbsp;</td>\n    <td style="width:33%;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 2" data-modal-title="Oplossing 2" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/5cc056e25ea145b495f564cb9da5e4c2.png&quot;></figure>">&nbsp;Oplossing 2&nbsp;</a>&nbsp;</td>\n    <td style="width:33%;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Oplossing 3" data-modal-title="Oplossing 3" data-modal-size="M" data-modal-content="<figure class=&quot;image&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/ea8d2c397bc34cd791b82d68fcdaffe5.png&quot;></figure>">&nbsp;Oplossing 3&nbsp;</a>&nbsp;</td>\n   </tr>\n  </tbody>\n </table>\n</figure>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2043245',
    info: '<h3 class="ck5h3">Extra opdracht: Zet de lasers uit&nbsp;- oplossing</h3>',
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 53,
    time: null,
    title: 'Oplossing',
    viewModes: ['PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">afsluitend filmpje</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2a6deed67d024effbdbbd2125ed9f2e6.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2061784',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 54,
    time: null,
    title: 'Afsluitend filmpje',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">outro<iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="100%" name="undefined" src="https://codefeverpublic.blob.core.windows.net/public-content/videos/3616abe49fd64e1f9a0bf4ea5a80f044.mp4" title="" width="100%">&nbsp;</iframe></h2>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2061785',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 55,
    time: null,
    title: 'Outro',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
];
